var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartnerVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 28,
    viewBox: "0 0 23 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4938 0.178607L1.86875 3.36102C0.7475 3.78535 0 4.83201 0 6.02011V12.6678C0 19.4994 4.49938 25.9208 10.6806 27.8727C11.2125 28.0424 11.7875 28.0424 12.3194 27.8727C18.5006 25.9208 23 19.5136 23 12.6678V6.02011C22.999 5.44453 22.8195 4.88295 22.4856 4.41035C22.1517 3.93775 21.6792 3.57662 21.1313 3.37517L12.5062 0.192751C11.8594 -0.0618425 11.1406 -0.0618424 10.4938 0.178607ZM11.5 21.027C7.5325 21.027 4.3125 17.8587 4.3125 13.9549C4.3125 10.0512 7.5325 6.8829 11.5 6.8829C15.4675 6.8829 18.6875 10.0512 18.6875 13.9549C18.6875 17.8587 15.4675 21.027 11.5 21.027Z",
    fill: "#008934"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.676 16.4935L8.28133 14.1809C8.16538 14.069 7.98165 14.0686 7.8653 14.1802L7.41252 14.6144C7.28967 14.7322 7.28932 14.9285 7.41176 15.0467L10.676 18.199L17.0314 12.3387C17.1525 12.2271 17.1609 12.0388 17.0504 11.9168L16.5413 11.3545C16.4283 11.2297 16.2347 11.2223 16.1125 11.3382L10.676 16.4935Z",
    fill: "#008934"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerVerify);
export default __webpack_public_path__ + "static/media/partner_verify.24d18d7c953f83b17a35618e61957fb3.svg";
export { ForwardRef as ReactComponent };